import React from "react";
import { connect } from "react-redux";
import { getAplicacionesExternas, eliminarAplicacionExterna } from "../aplicacionExterna/AplicacionExternaService";
import "../../styles/Empresa.css";
import AplicacionExternaDialogContent from "../aplicacionExterna/AplicacionExterna";
import Navbar from "../home/Navbar";
import AplicacionExternaDatos from "./AplicacionExternaDatos";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { Modal, Row, Col, Container, Button } from 'react-bootstrap'
import { esSesionAdmin } from "../usuario/Usuario";
import { obtenerListaEmpresas } from "../empresas/EmpresaService";
import delete_forever from '../../styles/icons/delete.svg';
import edit from '../../styles/icons/edit.svg';
import visibility from '../../styles/icons/visibility.svg';
import ExclamacionIcon from '../../styles/icons/exclamation-circle.svg'
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";

import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles.js";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import ModalDetalleConfiguraciones from "../componentes/modales/ModalDetalleConfiguraciones.js";
import NavbarConfiguraciones from "../componentes/NavbarConfiguraciones.js";
import TablaItemsConfiguracion from "../componentes/tablas/TablaItemsConfiguracion.js";

class aplicacionesExternas extends React.Component {
  constructor(props) {
    super(props);

    const { location } = this.props;
    const estado = location && location.state ? location.state : {};

    this.state = {
      selectedAplicacionExterna: {
        aplicacion: "",
        descripcion: "",
        url: "",
        usuario: "",
        pwd: "",
        id: "",
        idEmpresa: ""
      },
      aplicacionSeleccionada: null,
      mensajeFlash: estado.mensajeFlash || "",
      mostrarMensajeFlash: estado.mostrarMensajeFlash || false,
      mensajeFlashSeverity: estado.mensajeFlashSeverity || "neutral",
      dialogIsOpenVerDatos: false,
      eliminarAplicacionExterna: false,
      openPantallaCarga: false,
      listaEmpresas: null,
      listaEmpresaSelected: null,
      listaAplicacionesExternas: null,
    };
    this.modalRef = React.createRef();
    this.tablaRef = React.createRef();
    this.modalEliminarRef = React.createRef();
  }

  componentDidMount() {
    if (esSesionAdmin()) {
      obtenerListaEmpresas().then((res) => {
        this.setState({
          listaEmpresas: res.datos,
          listaEmpresaSelected: res.datos[0].id
        })
      })
    }
  }

  handleNewEmpresa = () => {
    this.handleDialog(true);
  };

  abrirModalEliminar = (estado, documento = null) => {
    this.setState({
      eliminarAplicacionExterna: estado,
      aplicacionSeleccionada: documento,
    });
  }

  cerrarModalEliminar = () => {
    this.setState({ eliminarAplicacionExterna: false });
  }

  manejarResultado = (resultado) => {
    this.setState({
      mostrarMensajeFlash: true,
      mensajeFlash: resultado.mensaje,
      mensajeFlashSeverity: !resultado.error ? "exito" : "error",
    })
  }

  handleEditarAplicacionExterna = (dato) => {
    this.props.history.push({
      pathname: '/configuracion/aplicaciones-externas/edit',
      state: { aplicacionExterna: dato }
    })
  }
  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchAplicacionesExternas(newPage, this.state.pageSize, "");
      });
    }
  }

  handleEliminarAplicacionExterna = () => {
    this.modalEliminarRef.cerrarModalConAnimacion()
    this.setState({ openPantallaCarga: true });
    let aplicacionExterna = this.state.aplicacionSeleccionada;

    eliminarAplicacionExterna(aplicacionExterna.id).then((res) => {
      this.setState({
        openPantallaCarga: false,
        mostrarMensajeFlash: true,
        mensajeFlash: res.mensaje,
        mensajeFlashSeverity: res.error ? 'error' : 'exito'
      });
      this.actualizarDatosTabla()
    })
  };

  handleDialogVerDatos = (estado, id = null) => {

    let aplicacionSeleccionada = this.state.listaAplicacionesExternas.find((elemento) => elemento.id === id)

    this.setState({ dialogIsOpenVerDatos: estado }, () => {
      if (estado && id && this.modalRef) {
        this.modalRef.cargarDetalles(aplicacionSeleccionada);
      }
    });

  };

  fetchAplicacionesExternas = (page, pageSize, search) => {
    return this.props.getAplicacionesExternas(page, pageSize, search).then(() => {
      const { aplicacionExternaData } = this.props;
      this.setState({ listaAplicacionesExternas: aplicacionExternaData.aplicacionExterna })
      return {
        items: aplicacionExternaData.aplicacionExterna,
        totalCount: aplicacionExternaData.totalCount,
      };
    });
  };

  fetchDetalle = (id) => {
    this.state.listaAplicacionesExternas.find((elemento) => elemento.id === id)
  }

  renderFilas = (filas) => {
    return filas.map((f) => (
      <tr key={f.id}>
        <td>{f.aplicacion}</td>
        <td>{f.descripcion}</td>
        <td>{f.url}</td>
        <td>{f.apikey}</td>
        <td>
          <div className="table-actions">
            <button className="table-icon open-dialog" onClick={() => this.handleDialogVerDatos(true, f.id)}
              data-id={f.id} data-dialog="modal-detalle-documento">
              <span className="material-symbols-outlined"> visibility </span>
            </button>
            <button className="table-icon open-dialog" onClick={() => this.handleEditarAplicacionExterna(f)}>
              <span className="material-symbols-outlined"> edit </span>
            </button>
            <button className="table-icon open-dialog" data-dialog="modal-delete-details"
              onClick={() => this.abrirModalEliminar(true, f)}>
              <span className="material-symbols-outlined"> delete </span>
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  actualizarDatosTabla = () => {
    if (this.tablaRef) {
      this.tablaRef.fetchData();
    }
  }

  render() {
    return (
      <div>
        <div className="template-base">
          <NavbarConfiguraciones
            titulo={"Aplicaciones externas"}
            descripcion={""}
            textoBoton={"Nueva aplicacion externa"}
            direccionBoton={"/configuracion/aplicaciones-externas/nuevo"}
          />
          <div className="wrapperContent">
            <div className="page-container">
              <TablaItemsConfiguracion
                ref={(ref) => (this.tablaRef = ref)}
                titulo="Tipos de documentos disponibles"
                headers={["Aplicacion", "Descripcion", "URL", "API Key", "Acciones"]}
                fetchDatos={this.fetchAplicacionesExternas}
                renderFilas={this.renderFilas}

              />
            </div>
            <MensajeFlash
              visible={this.state.mostrarMensajeFlash}
              mensaje={this.state.mensajeFlash}
              severity={this.state.mensajeFlashSeverity} />
          </div>

          <ModalEliminarConDetalles
            ref={(ref) => (this.modalEliminarRef = ref)}
            isOpen={this.state.eliminarAplicacionExterna}
            cerrarModal={this.cerrarModalEliminar}
            onConfirmar={this.handleEliminarAplicacionExterna}
            elemento={this.state.aplicacionSeleccionada}
            titulo="aplicacion externa"
            detallesAMostrar={[
              { clave: 'aplicacion', etiqueta: 'Nombre aplicacion externa' },
            ]}
            mensaje="Esta acción eliminará permanentemente el documento"
            textoBotonAccion="CONFIRMAR ELIMINACIÓN"
          />

          <ModalDetalleConfiguraciones
            ref={(ref) => (this.modalRef = ref)}
            abierto={this.state.dialogIsOpenVerDatos}
            onClose={() => this.handleDialogVerDatos(false)}
            fetchDetalle={null}
            titulo="Detalles de aplicacion externa"
            renderContenido={(datos) => (
              <div className="card">
                <p className="card-title">Datos Básicos</p>
                <div className="card-content">
                  <div className="content-inner">
                    <span className="label">Aplicacion</span>
                    <span className="txt">{datos.aplicacion}</span>
                  </div>
                  <div className="content-inner">
                    <span className="label">Descripción</span>
                    <span className="txt">{datos.descripcion}</span>
                  </div>
                  <div className="content-inner">
                    <span className="label">Empresa</span>
                    <span className="txt">{datos.empresa.nombre}</span>
                  </div>
                </div>
                <p className="card-title">Credenciales de la aplicacion</p>
                <div className="card-content">
                  <div className="content-inner">
                    <span className="label">URL</span>
                    <span className="txt">{datos.url}</span>
                  </div>
                  <div className="content-inner">
                    <span className="label">Nombre de usuario</span>
                    <span className="txt">{datos.usuario}</span>
                  </div>
                  <div className="content-inner">
                    <span className="label">API Key</span>
                    <span className="txt">{datos.apiKey}</span>
                  </div>
                </div>
              </div>
            )} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getAplicacionesExternas: (page, size, search) => dispatch(getAplicacionesExternas(page, size, search)),
});

const mapStateToProps = (state) => ({
  aplicacionExternaData: state.aplicacionExternaData,
});

export default connect(mapStateToProps, mapDispatchToProps)(aplicacionesExternas);
